// extracted by mini-css-extract-plugin
export default {"title":"InfoMessagesCard_title__iyx6y","body":"InfoMessagesCard_body__h+9Iv"};